var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 99,
    viewBox: "0 0 103 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 97.0806H1.5M1.5 42.0806L21.815 25.8306M101.5 42.0806L60.87 9.58057C58.2104 7.45302 54.9059 6.29394 51.5 6.29394C48.0941 6.29394 44.7896 7.45302 42.13 9.58057L38.22 12.7056M69 14.5806V4.58057C69 3.91753 69.2634 3.28164 69.7322 2.8128C70.2011 2.34396 70.837 2.08057 71.5 2.08057H84C84.663 2.08057 85.2989 2.34396 85.7678 2.8128C86.2366 3.28164 86.5 3.91753 86.5 4.58057V29.5806M11.5 97.0806V34.5806M91.5 34.5806V54.5806M91.5 97.0806V74.5806",
    stroke: "var(--text-normal)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 97.0806V72.0806C66.5 65.0106 66.5 61.4756 64.3 59.2806C62.11 57.0806 58.575 57.0806 51.5 57.0806C44.425 57.0806 40.895 57.0806 38.7 59.2806M36.5 97.0806V72.0806",
    stroke: "var(--text-normal)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5 34.5806C61.5 37.2327 60.4464 39.7763 58.5711 41.6516C56.6957 43.527 54.1522 44.5806 51.5 44.5806C48.8478 44.5806 46.3043 43.527 44.4289 41.6516C42.5536 39.7763 41.5 37.2327 41.5 34.5806C41.5 31.9284 42.5536 29.3849 44.4289 27.5095C46.3043 25.6341 48.8478 24.5806 51.5 24.5806C54.1522 24.5806 56.6957 25.6341 58.5711 27.5095C60.4464 29.3849 61.5 31.9284 61.5 34.5806Z",
    stroke: "var(--text-normal)",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon1);
export default __webpack_public_path__ + "static/media/loginIcon1.a72fe94d55c75ba6692661c4a3cfb6d7.svg";
export { ForwardRef as ReactComponent };